<template>
  <div
    class="singIn wx-login"
    v-if="showBindPhone">
    <div class="logo">
      <div class="backIcon">
        <i
          class="el-icon-back cursor"
          @click="back"></i>
      </div>
    </div>
    <div class='formBody'>
      <div style='text-align: center'>
        <p style="margin-bottom: 14px;color: #252525;font-size: 36px">{{$t('lang.bindTitle')}}</p>
        <p style="margin-bottom: 45px;color: #505050">{{$t('lang.bindTips')}}</p>
      </div>
      <div class="singInForm">
        <el-form
          :model="codeForm"
          :rules="rules"
          ref="codeForm">
          <el-form-item
            prop="phone"
            class="exchange">
            <span class="phone-icon">+86</span>
            <el-input
              class="phone-input"
              @keyup.enter.native="bindChange"
              v-model="codeForm.phone"
              :placeholder="$t('lang.bindPlaceholder')"></el-input>
          </el-form-item>
          <el-form-item
            prop="verifyCode"
            class="exchange">
            <el-input
              @keyup.enter.native="bindChange"
              class="code-input"
              v-model="codeForm.verifyCode"
              :placeholder="$t('lang.vcodeTip')"></el-input>
            <span
              class='cursor code-icon'
              @click='sendCode'>{{canSend ? $t('lang.sendCode') : timeNum + 's'}}</span>
          </el-form-item>
        </el-form>
        <el-button
          class="confirmBtn cursor phone-btn"
          :loading="isLoading"
          @click="bindChange">{{$t('lang.bindPhone')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlParam, getSession } from '@/assets/js/utils'
import { mapState } from 'vuex'
export default {
  name: 'WxLogin',
  data () {
    return {
      codeForm: {
        phone: '',
        verifyCode: ''
      },
      code_token: '',
      showBindPhone: false,
      canSend: true,
      timeNum: 59,
      domainName: '',
      isLoading: false
    }
  },
  computed: {
    rules () {
      return {
        phone: [
          { required: true, message: this.$t('lang.bindPlaceholder'), trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: this.$t('lang.enterTelTip'), trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: this.$t('lang.vcodeTip'), trigger: 'blur' }
        ]
      }
    },
    ...mapState({
      httpsFlag: 'httpsFlag',
      wxUrl: 'wxUrl',
      wxServiceName: 'wxServiceName'
    })
  },
  created () {
    this.getInfo()
    if (getUrlParam('code') && !getSession()) {
      this.codeGetToken()
    }
  },
  methods: {
    getInfo () {
      // 获取domain
      const localUrl = window.location.hostname
      const str1 = localUrl.split('.')[1]
      const str2 = localUrl.split('.')[2]
      this.domainName = `.${str1}.${str2}`
    },
    codeGetToken () {
      const params = {
        wechatCode: getUrlParam('code')
      }
      if (this.wxUrl && this.wxServiceName) {
        params.serverName = this.wxServiceName
        params.redirectUrl = this.wxUrl
      }
      this.axios.post('/userGroup/user-group/login/third/wechat', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.loginSuccess(res.data.result)
        } else if (res.data.errorCode == '80944303') {
          this.code_token = res.data.result
          this.showBindPhone = true
        } else if (res.data.errorCode == '80944301') {
          this.$message.error(this.$t('lang.signFail'))
          this.back()
        } else {
          this.$message.error(res.data.errorInfo)
          this.back()
        }
      }).catch(() => {
      })
    },
    bindChange () {
      this.$refs.codeForm.validate((valid) => {
        if (!valid) {
          return
        }
        const params = {
          platform: 'wechat',
          verifyCode: this.codeForm.verifyCode,
          phone: this.codeForm.phone,
          token: this.code_token
        }
        if (this.wxServiceName && this.wxUrl) {
          params.serverName = this.wxServiceName
          params.redirectUrl = this.wxUrl
        }
        this.isLoading = true
        this.axios.post('/userGroup/user-group/login/third/verifyMsgCode', params).then(res => {
          if (res.data.errorCode == '0x0') {
            this.loginSuccess(res.data.result)
          } else if (res.data.errorCode == '80944301') {
            this.$message.error(this.$t('lang.signFail'))
          } else if (res.data.errorCode == '80943304') {
            this.$message.error(this.$t('lang.vcodeEror'))
          } else if (res.data.errorCode == '80943305') {
            this.$message.error(this.$t('lang.error80943701'))
          } else {
            this.$message.error(res.data.errorInfo)
          }
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      })
    },
    sendCode () {
      if (!this.canSend) return
      const phone = this.codeForm.phone.replace(/\s*/g, '')
      if (!this.codeForm.phone || !(/^1[0-9]{10}$/.test(phone))) {
        return this.$message.error(this.$t('lang.enterTelTip'))
      }
      const params = {
        phone: this.codeForm.phone,
        token: this.code_token
      }
      this.axios.post('/userGroup/user-group/login/sendMsgCode', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('lang.sendSuccess'))
          this.sendCodeChange()
        } else if (res.data.errorCode == '80945301') {
          this.$message.error(this.$t('lang.error80945301'))
        } else if (res.data.errorCode == '80943201') {
          this.$message.error(this.$t('lang.error80943201'))
        } else if (res.data.errorCode == '80945302') {
          this.$message.error(this.$t('lang.error80945302'))
        } else {
          this.$message.error(res.data.errorInfo)
        }
      }).catch(() => {
      })
    },
    sendCodeChange () {
      this.canSend = false
      this.timeNum = 59
      this.timer = setInterval(() => {
        this.timeNum--
        if (this.timeNum == 0) {
          clearInterval(this.timer)
          this.canSend = true
        }
      }, 1000)
    },
    loginSuccess (data) {
      localStorage.setItem('email', data.email || this.codeForm.phone)
      localStorage.setItem('firstName', data.firstName)
      localStorage.setItem('userName', data.userName)
      localStorage.setItem('session', data.session)
      localStorage.setItem('userservice', data.userservice)
      window.userservice = data.userservice
      if (this.domainName) {
        // window.document.cookie = `SID=${data.session};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
        if (data.tagList && data.tagList.length > 0 && this.$store.state.saveTagCookie) {
          data.tagList.forEach(itm => {
            window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;domain=${this.domainName};${this.httpsFlag ? 'secure' : ''}`
          })
        }
      }
      // 此时设置sid有效
      this.$store.state.validSid = true
      // web跳转
      if (data.loginWelcome == '1') {
        this.$store.state.isSuccess = true
        this.$router.push('/welcome')
      } else {
        window.top.location.href = data.redirectUrl
      }
    },
    back () {
      this.$router.push('/qrcode')
    }
  }
}
</script>

<style scoped lang="less">
.wx-login {
  padding-top: 23px!important;
}
.input-phone {
  width: 75%;
}
.phone-btn {
  margin-top: 65px;
  margin-bottom: 36px;
}
.back-btn {
  text-align: center;
  color: #47A325;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.phone-icon {
  position: absolute;
  z-index: 2;
  left: 20px;
  top: 6px;
  font-size: 13px;
}
.phone-input /deep/.el-input__inner {
  padding: 15px 54px;
}
.code-icon {
  position: absolute;
  right: 12px;
  top: 4px;
  font-size: 13px;
  color: #47A325;
  font-weight: 500;
}
.confirmBtn {
  height: 41px;
  background: linear-gradient(241deg, #c1de00 0%, #5fa808 100%) rgba(255, 255, 255, 0.6);
  border-radius: 25px;
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  float: right;
}
</style>
